module.exports = __webpack_public_path__ + "static/media/SM-ST-O2-correct.7f50e713.mp3";